// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BJpUeu96GljAULkUJ14i{display:inline}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/businessProfile/store/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA","sourcesContent":[".descContentClassName {\n  display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descContentClassName": `BJpUeu96GljAULkUJ14i`
};
export default ___CSS_LOADER_EXPORT___;
